import { FC, useState } from 'react';

import { router } from '@inertiajs/react';

import { InfiniteScrollTrigger } from '../../components/shared/InfiniteScrollTrigger';

interface Props {
    url: string;
    nextPage: number | null;
}

export const ReviewsPagination: FC<Props> = ({ url, nextPage }) => {
    const [loading, setLoading] = useState(false);

    const loadMore = () => {
        if (!nextPage || loading) return;

        setLoading(true);

        router.get(
            url,
            { page: nextPage },
            {
                preserveScroll: true,
                preserveState: true,
                preserveUrl: true,
                only: ['reviews', 'nextPage'],
                onFinish: () => {
                    setLoading(false);
                },
            },
        );
    };

    if (!nextPage) return null;

    return <InfiniteScrollTrigger loading={loading} onLoadMore={loadMore} />;
};
